export const OPTIONS_KEY = Symbol('auth_module_options')
export const AUTH_STRATEGY_KEY = Symbol('auth_strategy')
